import { DefaultDisplayLocale } from '@shared/constants/localization/LocalizationConstants';
import deCommon from '@shared/locales/de/common.json';
import deError from '@shared/locales/de/error.json';
import deTour from '@shared/locales/de/tour.json';
import deUsecases from '@shared/locales/de/usecases.json';
import enCommon from '@shared/locales/en/common.json';
import enError from '@shared/locales/en/error.json';
import enTour from '@shared/locales/en/tour.json';
import enUsecases from '@shared/locales/en/usecases.json';
import esCommon from '@shared/locales/es/common.json';
import esError from '@shared/locales/es/error.json';
import esTour from '@shared/locales/es/tour.json';
import esUsecases from '@shared/locales/es/usecases.json';
import frCommon from '@shared/locales/fr/common.json';
import frError from '@shared/locales/fr/error.json';
import frTour from '@shared/locales/fr/tour.json';
import frUsecases from '@shared/locales/fr/usecases.json';
import itCommon from '@shared/locales/it/common.json';
import itError from '@shared/locales/it/error.json';
import itTour from '@shared/locales/it/tour.json';
import itUsecases from '@shared/locales/it/usecases.json';
import jaCommon from '@shared/locales/ja/common.json';
import jaError from '@shared/locales/ja/error.json';
import jaTour from '@shared/locales/ja/tour.json';
import jaUsecases from '@shared/locales/ja/usecases.json';

import { DisplayLocales } from '@shared/models/localization/Locales';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// todo: CDN for language translations - #515
// todo: cultural locales for fallback options
export const defaultNS = 'common';
export const namespaces = ['common', 'error', 'tour', 'usecases'];

export const resources: { [key in DisplayLocales]: any } = {
    en: {
        common: enCommon,
        error: enError,
        tour: enTour,
        usecases: enUsecases,
    },
    es: {
        common: esCommon,
        error: esError,
        tour: esTour,
        usecases: esUsecases,
    },
    fr: {
        common: frCommon,
        error: frError,
        tour: frTour,
        usecases: frUsecases,
    },
    it: {
        common: itCommon,
        error: itError,
        tour: itTour,
        usecases: itUsecases,
    },
    de: {
        common: deCommon,
        error: deError,
        tour: deTour,
        usecases: deUsecases,
    },
    ja: {
        common: jaCommon,
        error: jaError,
        tour: jaTour,
        usecases: jaUsecases,
    },
};

// set to true to enable pseudo localization
const pseudoEnabled = false; // process.env.ENABLED_ENVIRONMENT == "dev";

i18next
    // .use(
    //     new Pseudo({
    //         enabled: pseudoEnabled,
    //         letterMultiplier: 1,
    //     })
    // )
    .use(initReactI18next)
    .use(HttpBackend)
    .use(LanguageDetector)
    .init({
        returnNull: false,
        defaultNS: defaultNS,
        ns: namespaces,
        resources: resources,
        interpolation: {
            escapeValue: false,
        },
        debug: false,
        fallbackLng: DefaultDisplayLocale,
        fallbackNS: defaultNS,
        postProcess: ['pseudo'],
        partialBundledLanguages: true,
        backend: {
            // HttpBackend options
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'displayLocale',
        },
        lowerCaseLng: true,
        load: 'languageOnly',
    });

export default i18next;
